import React from 'react'
import { HeroRoot, HeroFlex, ImageColumn, CopyColumn, Header, ImageWrapper } from './Hero.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import hero from '../../../../../public/assets/raw-food-subscription/raw-food-subscription.webp'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'

type HeroProps = {}

export const Hero: React.FC<HeroProps> = ({}) => {
  const { t } = useTranslation()
  return (
    <HeroRoot>
      <HeroFlex>
        <ImageColumn>
          <Image src={hero} alt={t('raw-food-subscription:hero.image')} />
        </ImageColumn>
        <CopyColumn>
          <Header>
            <Stack direction="column" gap={{ '@initial': '1', '@bp2': '2' }}>
              <div>
                <span>{t('raw-food-subscription:hero.title-1')}</span>
                <span>{t('raw-food-subscription:hero.title-2')}</span>
              </div>
              <Text size="body">{t('raw-food-subscription:hero.subtitle')}</Text>
            </Stack>
          </Header>
        </CopyColumn>
      </HeroFlex>
    </HeroRoot>
  )
}
